export default function BlockWorldIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="0" y="0" width="64" height="64" rx="10" fill="#6EC6FF" />
      <circle cx="51" cy="12" r="7" fill="#FFD84A" />
      <rect x="0" y="36" width="64" height="28" fill="#93603D" />
      <rect x="0" y="34" width="64" height="3" fill="#7FDC4A" />
      <rect x="0" y="37" width="64" height="3" fill="#4FB53A" />
      <rect x="0" y="52" width="64" height="12" fill="#8F959E" />
      <path d="M12 58l2 -3l2 3l-2 3z" fill="#9FC3E6" />
      <path d="M42 57l2 -3l2 3l-2 3z" fill="#FFD23F" />
      <rect x="14" y="16" width="6" height="18" fill="#7A5130" />
      <rect x="6" y="6" width="22" height="14" fill="#3FAE37" />
      <rect x="10" y="3" width="14" height="5" fill="#3FAE37" />
      <rect x="37" y="28" width="11" height="6" fill="#3F9D4A" />
      <ellipse cx="42.5" cy="27" rx="6" ry="4" fill="#FFF2D6" />
      <rect x="38" y="27" width="9" height="4" fill="#3F9D4A" />
      <circle cx="42.5" cy="21" r="6" fill="#FF8A1F" />
      <circle cx="38.5" cy="14.5" r="2.2" fill="#FFD9A8" />
      <ellipse cx="44" cy="21.5" rx="4" ry="3.6" fill="#E0A070" />
      <circle cx="43" cy="21" r="1" fill="#20202C" />
      <circle cx="46" cy="21" r="1" fill="#20202C" />
      <path d="M50 24l8 -4M54 22l-6 14" stroke="#B5BBC4" strokeWidth="3" strokeLinecap="round" />
      <path d="M52 28l-4 8" stroke="#8F6038" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
